"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview25_exports = {};
__export(GeodesPreview25_exports, {
  default: () => GeodesPreview25_default
});
module.exports = __toCommonJS(GeodesPreview25_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.78125 5.07422C8.63802 5.41276 8.55339 5.8099 8.52734 6.26562C8.51432 6.72135 8.50781 7.21615 8.50781 7.75C8.50781 7.89323 8.45573 8.01693 8.35156 8.12109C8.26042 8.21224 8.14323 8.25781 8 8.25781C7.85677 8.25781 7.73307 8.21224 7.62891 8.12109C7.53776 8.01693 7.49219 7.89323 7.49219 7.75C7.49219 7.73698 7.49219 7.73047 7.49219 7.73047C7.49219 7.71745 7.49219 7.70443 7.49219 7.69141C7.49219 7.19661 7.50521 6.68229 7.53125 6.14844C7.57031 5.61458 7.67448 5.13281 7.84375 4.70312C7.9349 4.46875 8.05859 4.25391 8.21484 4.05859C8.37109 3.85026 8.5599 3.67448 8.78125 3.53125C9.0026 3.375 9.25651 3.26432 9.54297 3.19922C9.82943 3.12109 10.1484 3.08203 10.5 3.08203C10.8516 3.08203 11.1706 3.12109 11.457 3.19922C11.7435 3.26432 11.9974 3.375 12.2188 3.53125C12.4401 3.67448 12.6289 3.85026 12.7852 4.05859C12.9414 4.25391 13.0651 4.46875 13.1562 4.70312C13.3255 5.13281 13.4232 5.61458 13.4492 6.14844C13.4883 6.68229 13.5078 7.19661 13.5078 7.69141C13.5078 7.70443 13.5078 7.71745 13.5078 7.73047C13.5078 7.73047 13.5078 7.73698 13.5078 7.75C13.5078 7.89323 13.4557 8.01693 13.3516 8.12109C13.2604 8.21224 13.1432 8.25781 13 8.25781C12.8568 8.25781 12.7331 8.21224 12.6289 8.12109C12.5378 8.01693 12.4922 7.89323 12.4922 7.75C12.4922 7.21615 12.4792 6.72135 12.4531 6.26562C12.4401 5.8099 12.362 5.41276 12.2188 5.07422C12.1536 4.91797 12.0755 4.78125 11.9844 4.66406C11.9062 4.54688 11.8021 4.44271 11.6719 4.35156C11.5417 4.27344 11.3789 4.20833 11.1836 4.15625C11.0013 4.10417 10.7734 4.07812 10.5 4.07812C10.2266 4.07812 9.99219 4.10417 9.79688 4.15625C9.61458 4.20833 9.45833 4.27344 9.32812 4.35156C9.19792 4.44271 9.08724 4.54688 8.99609 4.66406C8.91797 4.78125 8.84635 4.91797 8.78125 5.07422ZM12.2383 15.543C12.3685 15.2435 12.4401 14.8984 12.4531 14.5078C12.4792 14.1042 12.4922 13.6549 12.4922 13.1602C12.4922 13.0299 12.5378 12.9193 12.6289 12.8281C12.7331 12.724 12.8568 12.6719 13 12.6719C13.1432 12.6719 13.2604 12.724 13.3516 12.8281C13.4557 12.9193 13.5078 13.0299 13.5078 13.1602C13.5078 13.1732 13.5078 13.1862 13.5078 13.1992C13.5078 13.2122 13.5078 13.2253 13.5078 13.2383C13.5078 13.681 13.4883 14.1432 13.4492 14.625C13.4232 15.1068 13.319 15.5495 13.1367 15.9531C13.0456 16.1615 12.9219 16.3633 12.7656 16.5586C12.6094 16.7409 12.4206 16.8971 12.1992 17.0273C11.9779 17.1576 11.724 17.2552 11.4375 17.3203C11.151 17.3854 10.8385 17.418 10.5 17.418C10.1615 17.418 9.84896 17.3854 9.5625 17.3203C9.27604 17.2552 9.02214 17.1576 8.80078 17.0273C8.57943 16.8971 8.39062 16.7409 8.23438 16.5586C8.07812 16.3633 7.95443 16.1615 7.86328 15.9531C7.68099 15.5495 7.57031 15.1068 7.53125 14.625C7.50521 14.1432 7.49219 13.681 7.49219 13.2383C7.49219 13.2253 7.49219 13.2122 7.49219 13.1992C7.49219 13.1862 7.49219 13.1732 7.49219 13.1602C7.49219 13.0299 7.53776 12.9193 7.62891 12.8281C7.73307 12.724 7.85677 12.6719 8 12.6719C8.14323 12.6719 8.26042 12.724 8.35156 12.8281C8.45573 12.9193 8.50781 13.0299 8.50781 13.1602C8.50781 13.6549 8.51432 14.1042 8.52734 14.5078C8.55339 14.8984 8.63151 15.2435 8.76172 15.543C8.82682 15.6732 8.89844 15.7904 8.97656 15.8945C9.06771 15.9987 9.17839 16.0898 9.30859 16.168C9.4388 16.2331 9.59505 16.2917 9.77734 16.3438C9.97266 16.3958 10.2135 16.4219 10.5 16.4219C10.7865 16.4219 11.0208 16.3958 11.2031 16.3438C11.3984 16.2917 11.5612 16.2331 11.6914 16.168C11.8216 16.0898 11.9258 15.9987 12.0039 15.8945C12.0951 15.7904 12.1732 15.6732 12.2383 15.543ZM10.5 7.24219C10.6432 7.24219 10.7604 7.29427 10.8516 7.39844C10.9557 7.48958 11.0078 7.60677 11.0078 7.75V12.75C11.0078 12.8932 10.9557 13.0169 10.8516 13.1211C10.7604 13.2122 10.6432 13.2578 10.5 13.2578C10.3568 13.2578 10.2331 13.2122 10.1289 13.1211C10.0378 13.0169 9.99219 12.8932 9.99219 12.75V7.75C9.99219 7.60677 10.0378 7.48958 10.1289 7.39844C10.2331 7.29427 10.3568 7.24219 10.5 7.24219Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview25 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview25_default = SvgGeodesPreview25;
